// 测面滑动菜单效果
const SHOW_MENU = true
const HIDE_MENU = false

const actionlist = {
  state: {
    isShow: false,
    detail: {
      title: 'title : by 把苹果咬哭',
      content: []
    }
  },
  mutations: {
    showActionMenu (state, obj) {
      state.detail = obj === undefined ? state.detail : obj.amount
      state.isShow = SHOW_MENU
    },
    hideActionMenu (state) {
      state.detail = {}
      state.isShow = HIDE_MENU
    }
  },
  actions: {
    showActionMenuList ({commit}, obj) {
      commit('showActionMenu', obj)
      // 解决当上传窗口打开，点击取消，下次无法上传的问题
      commit(`setStartUpload`, false)
    },
    hideActionMenuList ({commit}) {
      commit('hideActionMenu')
    }
  },
  getters: {
    getActionListIsShow: state => state.isShow,
    getShowActionMenuInfo: state => state.detail
  }
}
export default actionlist



// WEBPACK FOOTER //
// ./src/store/modules/currentFolderMenu.js